var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-tourplan-map" }, [
    _vm.isOptimizingRoute
      ? _c(
          "div",
          { staticClass: "loading-wrapper is-loading loading-wrapper--map" },
          [_c("div", { staticClass: "loading-message" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "leaflet-map leaflet-map--map" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { id: "rp-leaflet-map-" + _vm._uid },
      }),
      _vm._v(" "),
      _vm.message !== null
        ? _c("div", { staticClass: "leaflet-map--map__message" }, [
            _c("span", [_vm._v(_vm._s(_vm.message))]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }